import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  defineAsyncComponent,
  onMounted,
  computed,
  getCurrentInstance
} from 'vue';

// Helpers
import { useClampTabControl } from '@white-label-helper/shared-composables';
import { trackUpsellImpression, trackUpsellClick } from '@white-label-helper/ga-tracking';

// Types
import type { SearchProducts } from '@white-label-types/parking-booking';

// Components
import { Button as ControlButton } from 'ui-shared-components';

// Mocks
import mockedTravelInsuranceProduct from './mockedTravelInsuranceProduct.json'

interface TravelInsuranceProductCardProps {
  product?: Partial<SearchProducts>;
  battlefacePartnerId: Number,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-upsell-card',
  props: {
    product: { default: () => ({}) },
    battlefacePartnerId: null
  },
  setup(__props: any, { expose }) {

const props = __props as { product: Partial<SearchProducts>, battlefacePartnerId: Number };

const IconCheck = defineAsyncComponent(() => import('@white-label-icon/icon-check'));
const IconLink = defineAsyncComponent(() => import('@white-label-icon/icon-link'));



const instance = getCurrentInstance();
const proxy = instance?.proxy;

const clampedContainer = ref(null);
const startQuote = ref<any>(null);

const onButtonClick = () => {
  if (proxy?.$gtm) {
    trackUpsellClick(proxy.$gtm, product.value, props.battlefacePartnerId);
  }

  if (upsellUrl.value) {
    window.open(upsellUrl.value, '_blank', 'noopener,noreferrer');
  }
}

onMounted(() => {
  useClampTabControl(clampedContainer);
  if (proxy?.$gtm) {
    trackUpsellImpression(proxy.$gtm, product.value);
  }
});

const product = computed(() => {
  if (!props.product || Object.keys(props.product).length === 0) {
    return mockedTravelInsuranceProduct;
  }
  return props.product;
});

const upsellUrl = computed(() => {
  return `https://app.battleface.com?partner=${props.battlefacePartnerId}&reference=CONFPAGE`;
});

expose({
  upsellUrl,
})

return { __sfc: true,IconCheck, IconLink, props, instance, proxy, clampedContainer, startQuote, onButtonClick, product, upsellUrl, ControlButton }
}

})